(() => {
  const timer = document.querySelector('[data-countdown]');
  if (!timer) return;
  const output = timer.querySelector('[data-countdown-value]');
  const end = new Date(timer.dataset.endDate).getTime();
  const update = () => {
    const remaining = Math.max(0, end - Date.now());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    output.textContent = remaining ? `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s` : 'Offer ended';
  };
  update();
  setInterval(update, 1000);
})();
